import { React } from 'react';
import ListLinks from '../ListLinks/ListLinks';
import Loader from '../Loader/Loader';

const ListLinksSection = ({ isFetching, heading, links, type }) => {

    if (isFetching) {
        return <Loader spinner />;
    }

    return (
        <section className="list-links-section">
            <h2 className="list-links-section__heading">{heading}</h2>
            {links && <ListLinks links={links} type={type} />}
        </section>
    );
};

export default ListLinksSection;
